import { apiClient } from "@/lib/api-client";

export type UnsurPenunjangData = Record<string, any>;

export type UnsurPenunjangResponse = {
  datas: UnsurPenunjangData;
  message: string;
};

export const fetchUnsurPenunjang = async ({
  niu,
  year,
  semester,
  periodeID,
}: {
  niu: string;
  year: number;
  semester: number;
  periodeID?: number | null;
}): Promise<UnsurPenunjangData> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    ...(periodeID && { periodeID: periodeID.toString() }),
  });

  const resData = await apiClient<UnsurPenunjangResponse>(
    `${baseUrl}/api/v1/unsur-penunjang/${niu}?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return resData.datas;
};
